import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Collapse,
} from 'reactstrap';

const StyledList = styled.div`
  background-color: #0E2E42;
  font-size: 13.5px;
  font-family: Roboto, Helvetica, sans-serif;
  max-width: 18vw;
`;

const StyledCaret = styled(FontAwesomeIcon)`
  transition: all .2s ease-in;
`;

const Chevron = ({
  isOpen,
}) => (
  <StyledCaret
    icon="caret-right"
    className={`ml-2 ${isOpen ? 'fa-rotate-90' : ''} float-right`}
    size="lg"
  />
);

Chevron.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

const NavigatoresqueSideNav = ({
  items,
}) => (
  <StyledList>
    {items.map(item => (
      <NavigatoresqueSideNavItem
        item={item}

        key={item.id}
      />
    ))}
  </StyledList>
);

NavigatoresqueSideNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

const StyledItem = styled.div`
  padding: 11px;
  padding-left: ${p => (p.isChild ? '22px' : '11px')};
  color: #b3b3b3;
  background-color: ${p => (p.isChild ? '#0E2E42' : '#2B3E4F')};
  border-bottom: 2px solid ${p => (p.isChild ? '#2B3E4F' : '#0E2E42')};
  display: flex;
  justify-content: space-between;
  cursor: ${p => (p.isEditingList ? 'default' : 'pointer')};

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: white;
  }
`;

const NavigatoresqueSideNavItem = ({
  item,
  isChild,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (<>
    <StyledItem
      isChild={isChild}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="d-flex">
        {item.title}
      </div>

      <div className="d-flex">
        {item.children &&
          <Chevron
            isOpen={isOpen}
          />
        }
      </div>
    </StyledItem>

    {item.children && (
      <Collapse
        isOpen={isOpen}
      >
        {item.children.map(childItem => (
          <NavigatoresqueSideNavItem
            isChild
            item={childItem}

            key={childItem.id}
          />
        ))}
      </Collapse>
    )}
  </>);
};

export default NavigatoresqueSideNav;
